// extracted by mini-css-extract-plugin
export var comment = "Comment-module--comment--cfeda";
export var commentContainer = "Comment-module--comment-container--799aa";
export var commentMore = "Comment-module--comment-more--2f1bd";
export var commentMoreIcon = "Comment-module--comment-more-icon--cd1bc";
export var commentTag = "Comment-module--comment-tag--2e30a";
export var tagWrap = "Comment-module--tag-wrap--e1386";
export var title = "Comment-module--title--c7a18";